const API_BASE = import.meta.env.VITE_REPORT_API_URL ?? 'http://localhost:4500';
// ── API Functions ───────────────────────────────────────────
async function request(path, options) {
    const res = await fetch(`${API_BASE}/api/reports${path}`, {
        headers: { 'Content-Type': 'application/json' },
        ...options,
    });
    const data = await res.json();
    if (!res.ok)
        throw data;
    return data;
}
export function createReport(body) {
    return request('', { method: 'POST', body: JSON.stringify(body) });
}
export function getReport(reportId, sessionToken) {
    const headers = { 'Content-Type': 'application/json' };
    if (sessionToken)
        headers['Authorization'] = `Bearer ${sessionToken}`;
    return request(`/${reportId}`, { headers });
}
export function requestCode(reportId) {
    return request(`/${reportId}/request-code`, { method: 'POST' });
}
export function verifyCode(reportId, code) {
    return request(`/${reportId}/verify-code`, {
        method: 'POST',
        body: JSON.stringify({ code }),
    });
}
//# sourceMappingURL=report-api.js.map